module.exports = __webpack_public_path__ + "img/kishan.a3c04037.png";